import { RotateCcw } from "lucide-react";

const ReviewSidebar = ({
  activeItems,
  pendingItems,
  deletedItems,
  allCategories,
  newCount,
  filter,
  setFilter,
  showCategoryManager,
  undoStratagem,
}) => (
  <div className="space-y-6">
    <div className="hud-card clip-corners p-5" data-testid="review-stats">
      <h2 className="font-headings text-2xl uppercase tracking-widest text-white">Database Stats</h2>
      <div className="mt-4 space-y-2 text-sm">
        <p className="text-gray-400"><span className="text-white">Active:</span> {activeItems.length}</p>
        <p className="text-gray-400"><span className="text-white">Pending Review:</span>{" "}<span className="text-yellow-400">{pendingItems.length}</span></p>
        <p className="text-gray-400"><span className="text-white">Currently &ldquo;New&rdquo;:</span>{" "}<span className="text-green-400">{newCount}</span></p>
        <p className="text-gray-400"><span className="text-white">Deleted:</span> {deletedItems.length}</p>
        <p className="text-gray-400"><span className="text-white">Categories:</span> {allCategories.length}</p>
      </div>
    </div>

    <div className="hud-card clip-corners p-5" data-testid="review-deleted">
      <h2 className="font-headings text-2xl uppercase tracking-widest text-white">Deleted Entries</h2>
      {deletedItems.length === 0 ? (
        <p className="mt-4 text-sm text-gray-400">No deleted stratagems.</p>
      ) : (
        <ul className="mt-4 space-y-3 max-h-64 overflow-y-auto">
          {deletedItems.map((item) => (
            <li key={item.id} className="border border-white/10 p-3">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="font-headings uppercase tracking-wide text-white">{item.name}</p>
                  <p className="text-xs text-gray-500">{item.category}</p>
                </div>
                <button
                  onClick={() => undoStratagem(item)}
                  className="flex items-center gap-2 border border-[#FFE800]/40 px-3 py-1 text-xs font-data text-[#FFE800]"
                >
                  <RotateCcw className="h-4 w-4" />
                  Restore
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>

    {showCategoryManager && (
      <div className="hud-card clip-corners p-5">
        <h2 className="font-headings text-2xl uppercase tracking-widest text-white">All Categories</h2>
        <div className="mt-4 flex flex-wrap gap-2">
          {allCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`border px-3 py-2 text-xs font-headings uppercase tracking-[0.2em] ${
                filter === cat ? "border-[#FFE800] text-[#FFE800]" : "border-white/10 text-gray-400 hover:text-[#FFE800]"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>
    )}
  </div>
);

export default ReviewSidebar;
